import Faq from "@/components/faqs/Faq";
import Footer from "@/components/home/footer";
import Seo from "@/components/seo";
import { FaqsList } from "@utils/FaqsList";
import Link from "next/link";
import Header from "@components/header";

const Faqs = () => {
  return (
    <div>
      <Seo
        title="FAQ | Pinto Financial"
        description="Have Questions about Pinto Financial and how we best support your small business. Here Are The Answers To The Most Common Questions We Receive."
      />

      <Header />

      <div className="px-6 pt-12 lg:px-8 lg:pt-20 text-center">
        <p className=" mt-2 tracking-tight text-3xl sm:text-4xl lg:text-5xl">Frequently Asked Questions</p>
      </div>

      {/* Faqs content */}
      <div className="px-6 pt-20">
        {FaqsList.map((i) => (
          <div key={i.sectionTitle} className="mb-20">
            <h4 className="text-2xl font-semibold text-center mb-5">{i.sectionTitle}</h4>
            <div className="w-full flex flex-col items-center divide-y divide-slate-200">
              {i.items.map((faq) => (
                <div key={faq.answer} className="w-full max-w-3xl px-4 py-6 hover:bg-gray-50 transition duration-300 cursor-pointer">
                  <Faq question={faq.question} answer={faq.answer} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="px-6 pt-5 pb-40 lg:px-8  bg-white flex flex-col text-center">
        <p className="mt-2 mb-4 text-3xl tracking-tight lg:text-4xl">Still have a question?</p>
        <Link
          className="transition hover:underline hover:text-pinto py-2 sm:ml-6 text-base font-semibold leading-7 text-gray-900"
          href="https://calendly.com/pintofinancial/15min"
        >
          Book A Call With Us
          <span aria-hidden="true"> &rarr;</span>
        </Link>
      </div>

      <Footer />
    </div>
  );
};

export default Faqs;
